'use client';

import classNames from 'classnames';
import Video, { VideoDataProps } from '../Video/Video';
import styles from './VideoCard.module.scss';

type VideoCardProps = {
  stepNumber: number,
  title: string,
  description: string,
  video: VideoDataProps,
};

const VideoCard = ({
  stepNumber, title, description, video,
}: VideoCardProps) => (
  <div className={styles.videoCard}>
    <div className={styles.videoCard__info}>
      <p className={classNames(styles.videoCard__infoStep, 'subtitle')}>
        Step
        {' '}
        {stepNumber}
      </p>
      <p className={classNames(styles.videoCard__infoTitle, 'header3')}>{title}</p>
      <p className={classNames(styles.videoCard__infoDescription, 'bodyLarge')}>{description}</p>
    </div>
    <Video
      video={video}
      view='default'
      activeIndex={0}
      videoWrapperClassName={styles.videoCard__videoWrapper}
      videoClassName={styles.videoCard__video}
      videoPreviewClassName={styles.videoCard__videoPreview}
    />
  </div>
);

export default VideoCard;
